export default {
    props: {
        tileSizeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tileSize.width'
        }, 
        tileSizeHeight: {
            type: Number,
            default: undefined,
            kComposite: 'tileSize.height'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/Common/TileSize.js